export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-radio-list/index.js